"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailVerificationStep = void 0;
const BaseUserOnboardingStep_1 = require("../../common/domain/BaseUserOnboardingStep");
const CommonOnboardingStepId_1 = require("../../common/domain/CommonOnboardingStepId");
const validator_1 = require("@leavy/validator");
const EmailVerification_1 = require("./EmailVerification");
class EmailVerificationStep extends BaseUserOnboardingStep_1.BaseUserOnboardingStep {
    constructor() {
        super(...arguments);
        this.stepId = CommonOnboardingStepId_1.CommonOnboardingStepId.EMAIL_VERIFICATION;
    }
    getDataConstructor() {
        return EmailVerification_1.EmailVerification;
    }
    getDefaultData() {
        return new EmailVerification_1.EmailVerification({ emailVerified: false });
    }
}
__decorate([
    (0, validator_1.Type)(() => EmailVerification_1.EmailVerification),
    __metadata("design:type", EmailVerification_1.EmailVerification)
], EmailVerificationStep.prototype, "data", void 0);
exports.EmailVerificationStep = EmailVerificationStep;
//# sourceMappingURL=EmailVerificationStep.js.map